const Button = ({
  title,
  isDisabled = false,
  onClick,
  type = "button",
  className = "",
}: {
  title: string;
  isDisabled: boolean;
  onClick?: () => void;
  type: "button" | "submit";
  className?: string;
}) => {
  return (
    <button
      className={`border p-2 h-[calc(60px)] w-full ${className}`}
      style={{
        backgroundColor: isDisabled ? "var(--color-disabled)" : undefined,
        color: isDisabled ? "var(--color-disabled-text)" : undefined,
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
      type={type}
      disabled={isDisabled}
      onClick={isDisabled ? () => null : onClick}
    >
      {title}
    </button>
  );
};

export default Button;
